import styled from 'styled-components';

export const WrappedTableContainer = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  width: 100%;
  grid-row: span 24;
  padding: 10px;

  .ant-table-container {
    font-size: 14px;

    td {
      vertical-align: top !important;
    }
  }

  .ant-table-cell {
    padding: 10px !important;
  }
`;

// Header is intentionally omitted here; use shared HeaderSection/HeaderTitle from MetricPanel/styled.ts

export const RootCause = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  color: #666;
  align-items: flex-start;
  margin-right: 5px;

  > span {
    font-size: 10px;
    color: #999;
    margin-top: 2px;
  }

  .ant-tag {
    color: #333;
    font-size: 12px;
    margin-top: 0;
  }
`;

export const RootCauseWrapper = styled.div<{
  $drilldown: boolean;
}>`
  display: flex;
  flex-flow: row wrap;
  cursor: pointer;

  &:hover {
    span {
      color: ${(props) => (props.$drilldown ? '#215bff' : '##999')};
    }

    .ant-tag {
      color: ${(props) => (props.$drilldown ? '#215bff' : '##999')};
      border-color: ${(props) => (props.$drilldown ? '#215bff' : '##999')};
    }
  }
`;

export const SeverityLabel = styled.span<{ color }>`
  color: ${(props) => props.color};
`;

export const FilterTagsContainer = styled.div`
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  padding: 0 10px;

  .ant-tag {
    cursor: pointer;
    user-select: none;
    border: 1px solid #d9d9d9;
    background: #fafafa;

    &.ant-tag-checkable-checked {
      background-color: #1890ff;
      border-color: #1890ff;
      color: white;
    }

    &:hover {
      opacity: 0.8;
    }
  }
`;
